import { createStorage } from "wagmi";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { bsc, bscTestnet } from "@reown/appkit/networks";
import type { Chain } from "viem";

// Read Project ID from environment variables
export const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;

// Ensure Project ID is defined
if (!projectId || projectId === "YOUR_PROJECT_ID_HERE") {
  console.warn(
    "REACT_APP_WALLETCONNECT_PROJECT_ID is not properly configured. Please set it in .env file",
  );
  // For development, we'll continue with a warning, but this should be fixed for production
}

// Define supported networks based on testnet configuration
export const networks: [Chain, ...Chain[]] =
  process.env.REACT_APP_USE_TESTNET === "true" ? [bscTestnet] : [bsc];

// Create the Wagmi adapter instance
export const wagmiAdapter = new WagmiAdapter({
  storage: createStorage({ storage: localStorage }), // Use localStorage for React app (not SSR)
  ssr: false, // React app, not Next.js
  projectId: projectId || "temp-project-id", // Fallback for development
  networks,
});

// Export the Wagmi config generated by the adapter
export const config = wagmiAdapter.wagmiConfig;

// App metadata for WalletConnect
export const metadata = {
  name: "DeathX.Fun",
  description: "Provably Fair Blockchain Game",
  url:
    typeof window !== "undefined"
      ? window.location.origin
      : "https://deathx.fun",
  icons: ["https://deathx.fun/icon-with-bg.png"],
};
